/* eslint-disable max-lines */
import { CFTokens } from '../../../../../tokens';
export const BORDER_COLOR = {
    ALTERNATE: {
        attention: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_LEMONADE_MID_TONE,
        },
        danger: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        neutral: {
            strong: CFTokens.COLOR.MONO_4,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        primary: {
            strong: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_MID_TONE,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        success: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        warning: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
    },
    DEFAULT: {
        attention: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_LEMONADE_MID_TONE,
        },
        danger: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_MID_TONE,
        },
        neutral: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.MONO_4,
        },
        primary: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_MID_TONE,
        },
        success: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.FOREST_5,
        },
        warning: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_MID_TONE,
        },
    },
};
export const ICON_COLOR = {
    ALTERNATE: {
        attention: {
            strong: 'text-and-element-brand',
            subtle: 'text-and-element-brand',
        },
        danger: {
            strong: 'chromatic-strawberry-alternate-subtle',
            subtle: 'chromatic-strawberry-alternate-contrast',
        },
        neutral: {
            strong: 'text-and-element-default',
            subtle: 'text-and-element-alternate',
        },
        primary: {
            strong: 'chromatic-primary-alternate-subtle',
            subtle: 'chromatic-primary-alternate-contrast',
        },
        success: {
            strong: 'chromatic-forest-alternate-subtle',
            subtle: 'chromatic-forest-alternate-contrast',
        },
        warning: {
            strong: 'chromatic-grapefruity-alternate-subtle',
            subtle: 'chromatic-grapefruity-alternate-subtle',
        },
    },
    DEFAULT: {
        attention: {
            strong: 'text-and-element-brand',
            subtle: 'text-and-element-brand',
        },
        danger: {
            strong: 'chromatic-strawberry-subtle',
            subtle: 'chromatic-strawberry-contrast',
        },
        neutral: {
            strong: 'text-and-element-alternate',
            subtle: 'text-and-element-default',
        },
        primary: {
            strong: 'chromatic-primary-subtle',
            subtle: 'chromatic-primary-contrast',
        },
        success: {
            strong: 'chromatic-forest-subtle',
            subtle: 'chromatic-forest-contrast',
        },
        warning: {
            strong: 'chromatic-grapefruity-contrast',
            subtle: 'chromatic-grapefruity-contrast',
        },
    },
};
export const ROOT_COLOR = {
    ALTERNATE: {
        attention: {
            strong: CFTokens.COLOR.CHROMATIC_LEMONADE_ALTERNATE_MID_TONE,
            subtle: CFTokens.COLOR.CHROMATIC_LEMONADE_ALTERNATE_SUBTLE,
        },
        danger: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_SUBTLE,
        },
        neutral: {
            strong: CFTokens.COLOR.BACKGROUND_COOL_2,
            subtle: CFTokens.COLOR.MONO_7,
        },
        primary: {
            strong: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_SUBTLE,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_SUBTLE,
        },
        warning: {
            strong: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_ALTERNATE_MID_TONE,
        },
    },
    DEFAULT: {
        attention: {
            strong: CFTokens.COLOR.CHROMATIC_LEMONADE_DEFAULT,
            subtle: CFTokens.COLOR.CHROMATIC_LEMONADE_SUBTLE,
        },
        danger: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_SUBTLE,
        },
        neutral: {
            strong: CFTokens.COLOR.MONO_7,
            subtle: CFTokens.COLOR.BACKGROUND_COOL_2,
        },
        primary: {
            strong: CFTokens.COLOR.CHROMATIC_PRIMARY_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_SUBTLE,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_SUBTLE,
        },
        warning: {
            strong: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_MID_TONE,
            subtle: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_SUBTLE,
        },
    },
};
export const TEXT_COLOR = {
    ALTERNATE: {
        attention: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        },
        danger: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_CONTRAST,
        },
        neutral: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        },
        primary: {
            strong: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_CONTRAST,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_CONTRAST,
        },
        warning: {
            strong: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_ALTERNATE_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_ALTERNATE_SUBTLE,
        },
    },
    DEFAULT: {
        attention: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        },
        danger: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
        },
        neutral: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        },
        primary: {
            strong: CFTokens.COLOR.CHROMATIC_PRIMARY_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_CONTRAST,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_CONTRAST,
        },
        warning: {
            strong: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_GRAPEFRUITY_CONTRAST,
        },
    },
};
